import { cn } from '../../lib/cn';
import { Card, KpiCard } from '../ui';
import type { RoleSpec } from '../../rolexp/framework';
import { kpiLabel, dashboardLabel } from '../../rolexp/framework';

type Props = {
  role: RoleSpec;
  kpis?: { label: string; value: string; hint?: string }[];
  className?: string;
};

const DEFAULT_KPIS = [
  { label: 'Revenue (30d)', value: '$128.4K', hint: '+12%' },
  { label: 'ROAS', value: '5.8', hint: 'Portfolio' },
  { label: 'Business Health', value: '87', hint: 'Good' },
];

export function RoleCockpit({ role, kpis = DEFAULT_KPIS, className }: Props) {
  return (
    <Card className={cn(className)}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">
            {dashboardLabel(role.dashboard)}
          </p>
          <p className="text-lg font-semibold text-slate-900 dark:text-slate-100">{role.label} Cockpit</p>
        </div>
        {role.default_home && (
          <span className="text-xs text-slate-400">Home: {role.default_home}</span>
        )}
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {kpis.map((kpi) => (
          <KpiCard key={kpi.label} label={kpi.label} value={kpi.value} hint={kpi.hint} />
        ))}
      </div>
      {role.kpis && role.kpis.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1">
          {role.kpis.map((k) => (
            <span key={k} className="rounded-md bg-slate-100 px-2 py-0.5 text-[10px] text-slate-600 dark:bg-slate-800 dark:text-slate-400">
              {kpiLabel(k)}
            </span>
          ))}
        </div>
      )}
    </Card>
  );
}
